<template>
    <div>
        <v-img eager :src="src" :max-width="maxWidth" @click.stop="open" class="image" />
        <v-dialog v-model="zoom" hide-overlay>
            <div class="dialog">
                <v-btn small icon @click="zoom = false" class="close"><v-icon small>mdi-close</v-icon></v-btn>
                <img :src="src" :alt="alt" class="img" />
            </div>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        src: String,
        alt: String,
        maxWidth: String,
    },

    data() {
        return {
            zoom: false,
        }
    },

    methods: {
        open() {
            if (this.$vuetify.breakpoint.smAndDown) {
                return;
            }
            this.zoom = true;
        }
    },
}
</script>

<style scoped>
.image {
    margin: 0 auto;
    cursor: pointer;
}
.dialog {
    position: relative;
    display: flex;
    padding: 20px;
}
.img {
    display: block;
    margin: auto;
    max-width: calc(100% - 40px);
    max-height: calc(90vh - 40px);
    width: auto;
}
.close {
    position: absolute;
    top: 10px;
    right: 10px;
}
</style>